<template>
    <div class="container bg_fff">
        <breadcrumb :pages="pages"></breadcrumb>
        <div class="pl15 pr15 pt15 pb15">
            <referral-search-form @search="search"></referral-search-form>
            <referral-tabs v-model="tab"></referral-tabs>
            <div class="mt15">
                <el-table border size="mini" :data="list" :header-cell-style="{backgroundColor:'#fafafa'}">
                    <el-table-column label="状态" prop="referralStatusDescription"></el-table-column>
                    <el-table-column label="安排转诊日期" prop="acceptTime" v-if="tab == '4'" :formatter="_formatterTime"></el-table-column>
                    <el-table-column label="编号" prop="referralOrderNo"></el-table-column>
                    <el-table-column label="姓名" prop="patName"></el-table-column>
                    <el-table-column label="性别" prop="patGender" :formatter="_formatterSex"></el-table-column>
                    <el-table-column label="年龄" prop="patAge"></el-table-column>
                    <el-table-column label="申请时间" prop="createTime" :formatter="_formatterTime"></el-table-column>
                    <el-table-column label="申请医生" prop="initDocName"></el-table-column>
                    <el-table-column label="申请医院" prop="initHosName" v-if="$route.meta.type == 'accept'"></el-table-column>
                    <el-table-column label="预约医院" prop="hopeHosName"></el-table-column>
                    <el-table-column label="预约科室" prop="hopeDeptName"></el-table-column>
                    <el-table-column label="预约医生" prop="hopeDocName"></el-table-column>
                    <el-table-column label="预约转诊日期" prop="hopeTime" :formatter="_formatterTime"></el-table-column>
                    <el-table-column label="操作" fixed="right" :width="labelWidth">
                        <template slot-scope="{row}">
                            <el-button size="mini" @click="doReferralAction('会诊单',row)"
                                       v-if="row.referralStatus==='FINSH'">
                                转诊单
                            </el-button>
                            <el-button size="mini" @click="doReferralAction('详情',row)" type="primary">详情</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pt15">
                <el-pagination
                    @current-change="pageChange"
                    :page-size="page.pageSize"
                    layout="total, prev, pager, next, jumper"
                    :total="page.total">
                </el-pagination>
            </div>
        </div>
        <referral-print ref="print"></referral-print>
    </div>
</template>

<script>
  import Breadcrumb from "../components/common/Breadcrumb";
  import {referralMixin} from "../lib/mixins/referral";
  import ReferralSearchForm from "../components/referral/search-form";
  import ReferralTabs from "../components/referral/tabs";
  import {referralService} from "../lib/service/referral";
  import {referralFormMixin} from "../lib/mixins/referral-form";
  import ReferralPrint from "../components/referral/print";
  import {timeFormat} from "../lib/utils"

  export default {
    name: "Referral",
    data() {
      return {
        tab: ['2'],
        page: {},
        form: {
          pageSize: 10,
          pageNum: 1
        },
        list: ['1']
      }
    },
    computed: {
      labelWidth() {
        const {tab} = this;
        const width = {
          '2': 90,
          '4': 180,
          '-1': 180,
        };
        for (let key in width) {
          if (tab.includes(key)) return width[key];
        }
        return 90;
      }
    },
    components: {ReferralPrint, ReferralTabs, ReferralSearchForm, Breadcrumb},
    mixins: [referralMixin, referralFormMixin],
    created() {
    },
    mounted() {
        this.setFormReferralType();//判断页面来源类型  outpatient = 门诊  hospitalization = 住院
        this.getList();
    },
    watch: {
      tab() {
        this.resetFormReferral();
        this.getList();
      },
      $route() {
        this.resetFormReferral();
        this.setFormReferralType();
        this.getList();
      }
    },
    methods: {
        _formatterSex(row, column, cellValue){
            return cellValue == 'F' ? '女' : '男'
        },
        _formatterTime(row, column, cellValue){
            if(cellValue == undefined || cellValue == "")return ''
            return timeFormat(cellValue,'%Y-%m-%d %H:%M');
        },
      search(data) {
        this.form = {...this.form, ...data};
        this.form.pageNum = 1;
        let start = this.form.startTime.substring(0,4)+this.form.startTime.substring(5,7)+this.form.startTime.substring(8,10)
        let end = this.form.endTime.substring(0,4)+this.form.endTime.substring(5,7)+this.form.endTime.substring(8,10)
        if(end<start){
          this.$message.error('请合理选择时间范围！')
          return
        }
        this.getList();
      },
      pageChange(page) {
        this.form.pageNum = page;
        this.getList();
      },
      async getList() {
        let {form, tab} = this;
        const {meta} = this.$route;
        let action = '';
        if (meta.type === 'init') {
          action = 'initList';
        } else if (meta.type === 'accept') {
          action = 'acceptList';
        }
        form.referralStatusList = tab;
        const {list, page} = await referralService[action](form);
        this.list = list;
        this.page = page;
      }
    },
  }
</script>

<style scoped lang="scss">

</style>
